/*
  Bisou Memoire: Perfume shelf (Creaeza)

  - Bottles stand on a stone shelf. Desktop: hover lifts a bottle. Phones: the bottle in the middle
    lifts as the shelf is swiped.
  - A soft mist in the perfume's colour rises from the lifted bottle (canvas, only while on screen)
    and its notes float up: top, heart, base. Notes are read from the product description
    ("Top Notes ... Middle Notes ... Base Notes ...") or from the block fields.
  - Click or tap opens a panel: the bottle flies in, mist rises, tap to spray, note pyramid,
    sizes, Add to bag through the theme's cart drawer.
*/
(function () {
  'use strict';

  if (window.BisouPerfumeShelf) return;

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  var uid = 0;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function json(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function resize(src, w) {
    if (!src) return '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function titleCase(s) {
    return s.toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
  }

  /* ---------- notes ---------- */
  function splitNotes(str) {
    return String(str || '')
      .replace(/^\s*(are|is|include|includes)?\s*[:\-]?\s*/i, '')
      .replace(/\s+(and|&)\s+/gi, ', ')
      .split(/\s*[,;·•|\/]\s*/)
      .map(function (s) { return s.trim().replace(/^(and|&)\s+/i, '').replace(/[.:;!]+$/, '').replace(/\s*-\s*/g, '-').trim(); })
      .filter(function (s) { return s && s.length < 34 && !/^(top|middle|heart|base)?\s*notes?$/i.test(s); })
      .map(titleCase);
  }

  function parseNotes(d) {
    var n = d.notes || {};
    var out = { top: splitNotes(n.top), heart: splitNotes(n.heart), base: splitNotes(n.base) };
    var t = String(d.description || '').replace(/\s+/g, ' ');
    var grab = function (re) { var m = re.exec(t); return m ? m[1] : ''; };
    if (!out.top.length) out.top = splitNotes(grab(/top\s*notes?\s*[:\-]?\s*(.+?)(?=\b(?:middle|heart)\s*notes?\b|\bbase\s*notes?\b|$)/i));
    if (!out.heart.length) out.heart = splitNotes(grab(/(?:middle|heart)\s*notes?\s*[:\-]?\s*(.+?)(?=\bbase\s*notes?\b|$)/i));
    if (!out.base.length) out.base = splitNotes(grab(/base\s*notes?\s*[:\-]?\s*(.+?)(?:\.\s|\.$|$)/i));
    out.any = out.top.length + out.heart.length + out.base.length > 0;
    if (!out.any && n.key) { out.key = splitNotes(n.key); out.any = out.key.length > 0; }
    return out;
  }

  function moodOf(d) {
    if (d.mood) return d.mood;
    var t = String(d.description || '').replace(/\s+/g, ' ').trim();
    t = t.split(/\b(?:top\s*notes?|notes?\s*:)/i)[0].trim();
    var m = /^(.{20,180}?[.!?])(\s|$)/.exec(t);
    return m ? m[1] : (t.length > 160 ? t.slice(0, 157).replace(/\s+\S*$/, '') + '...' : t);
  }

  function sizesOf(d) {
    var vs = (d.variants || []).map(function (v) {
      var m = /(\d+(?:\.\d+)?)\s*ml/i.exec(v.title || '');
      return { id: v.id, ml: m ? parseFloat(m[1]) : 0, label: m ? m[1] + ' ml' : (v.title === 'Default Title' ? '' : v.title), price: v.price, compare: v.compare, available: v.available };
    });
    vs.sort(function (a, b) { return b.ml - a.ml; });
    return vs;
  }
  function defaultSize(sizes) {
    return sizes.filter(function (v) { return v.available; })[0] || sizes[0] || null;
  }

  /* ---------- mist ---------- */
  function Mist(canvas, maxDpr) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.parts = [];
    this.sprites = {};
    this.maxDpr = maxDpr || 2;
    this.fit();
  }
  Mist.prototype.fit = function () {
    var r = this.canvas.getBoundingClientRect();
    this.w = r.width; this.h = r.height;
    this.dpr = Math.min(window.devicePixelRatio || 1, this.maxDpr);
    this.canvas.width = Math.max(1, Math.round(r.width * this.dpr));
    this.canvas.height = Math.max(1, Math.round(r.height * this.dpr));
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
  };
  Mist.prototype.sprite = function (hex) {
    if (this.sprites[hex]) return this.sprites[hex];
    var c = document.createElement('canvas');
    c.width = c.height = 64;
    var g = c.getContext('2d');
    var h = String(hex || '#d9c7a3').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var r = parseInt(h.slice(0, 2), 16) || 217, gg = parseInt(h.slice(2, 4), 16) || 199, b = parseInt(h.slice(4, 6), 16) || 163;
    var grad = g.createRadialGradient(32, 32, 0, 32, 32, 32);
    grad.addColorStop(0, 'rgba(' + r + ',' + gg + ',' + b + ',.9)');
    grad.addColorStop(0.5, 'rgba(' + r + ',' + gg + ',' + b + ',.32)');
    grad.addColorStop(1, 'rgba(' + r + ',' + gg + ',' + b + ',0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, 64, 64);
    this.sprites[hex] = c;
    return c;
  };
  Mist.prototype.add = function (x, y, hex, n, power, scale) {
    power = power || 1; scale = scale || 1;
    for (var i = 0; i < n; i++) {
      this.parts.push({
        x: x + rand(-14, 14) * scale, y: y + rand(-6, 4) * scale,
        vx: rand(-24, 24) * power * scale, vy: -rand(14, 36) * power * scale,
        r: rand(14, 28) * scale, g: rand(18, 38) * scale,
        life: 0, max: rand(2.8, 4.6), a: rand(0.035, 0.075), s: Math.random() * 6.283, hex: hex
      });
    }
    if (this.parts.length > 240) this.parts.splice(0, this.parts.length - 240);
  };
  Mist.prototype.shift = function (dx) { for (var i = 0; i < this.parts.length; i++) this.parts[i].x += dx; };
  Mist.prototype.step = function (dt, t) {
    var ctx = this.ctx, parts = this.parts;
    ctx.clearRect(0, 0, this.w, this.h);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.life += dt;
      if (p.life >= p.max) { parts.splice(i, 1); continue; }
      p.vx *= 1 - 0.7 * dt;
      p.vy = p.vy * (1 - 0.45 * dt) - 5 * dt;
      p.x += (p.vx + Math.sin(t * 1.1 + p.s) * 7) * dt;
      p.y += p.vy * dt;
      p.r += p.g * dt;
      var k = p.life / p.max;
      var alpha = p.a * Math.min(1, p.life / 0.35) * (1 - k * k);
      if (alpha <= 0.002) continue;
      ctx.globalAlpha = alpha;
      ctx.drawImage(this.sprite(p.hex), p.x - p.r, p.y - p.r, p.r * 2, p.r * 2);
    }
    ctx.globalAlpha = 1;
    return parts.length;
  };
  Mist.prototype.clear = function () { this.parts = []; this.ctx.clearRect(0, 0, this.w, this.h); };

  /* ---------- the shelf ---------- */
  function Shelf(root) {
    var self = this;
    this.root = root;
    this.id = 'bps' + (++uid);
    this.cfg = json(root.querySelector('[data-bps-config]')) || {};
    this.text = this.cfg.text || {};
    this.reduced = reduceMQ.matches;
    this.mistAmount = this.reduced ? 0 : clamp(Number(this.cfg.mist) || 0, 0, 10);
    this.stage = root.querySelector('[data-bps-stage]');
    this.viewport = root.querySelector('[data-bps-viewport]');
    this.track = root.querySelector('[data-bps-track]');
    this.spot = root.querySelector('[data-bps-spot]');
    this.notesEl = root.querySelector('[data-bps-notes]');
    this.canvas = root.querySelector('[data-bps-mist]');
    this.prevBtn = root.querySelector('[data-bps-prev]');
    this.nextBtn = root.querySelector('[data-bps-next]');
    this.infoBody = root.querySelector('[data-bps-info-body]');
    this.openBtn = root.querySelector('[data-bps-open]');
    this.tabsEl = root.querySelector('[data-bps-tabs]');
    this.tabLine = root.querySelector('[data-bps-tab-line]');

    this.items = [].slice.call(root.querySelectorAll('[data-bps-item]')).map(function (li, i) {
      var data = json(li.querySelector('[data-bps-json]')) || {};
      return {
        i: i, li: li, data: data,
        bottle: li.querySelector('[data-bps-bottle]'),
        lift: li.querySelector('[data-bps-lift]'),
        img: li.querySelector('img.bps-img'),
        group: li.getAttribute('data-group') || '',
        blockId: li.getAttribute('data-block-id'),
        notes: parseNotes(data),
        mood: moodOf(data),
        sizes: sizesOf(data),
        visible: true
      };
    });
    if (!this.items.length) return;

    this.visible = this.items.slice();
    this.filter = 'all';
    this.active = null;
    this.listeners = [];
    this.lastScroll = this.viewport.scrollLeft;
    this.mist = (this.mistAmount && this.canvas && this.canvas.getContext) ? new Mist(this.canvas, 1.75) : null;

    this.measure();
    this.setMode();
    this.bind();
    this.updateTabs(false);
    this.roving(this.items[0]);
    var mid = this.middle();
    if (mid) this.updateInfo(mid, true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.moveTabLine(false); });

    if (this.reduced) this.startActive(false);
    else root.classList.add('is-pre');
    this.observe();
  }

  Shelf.prototype.on = function (el, type, fn, opts) {
    el.addEventListener(type, fn, opts || false);
    this.listeners.push([el, type, fn, opts || false]);
  };

  Shelf.prototype.measure = function () {
    var first = this.visible[0] || this.items[0];
    var H = first.li.offsetHeight || 400;
    var cs = getComputedStyle(this.root);
    var head = this.track ? parseFloat(getComputedStyle(this.track).paddingTop) || 200 : 200;
    this.m = { H: H, W: H * 2 / 3, slot: first.li.offsetWidth || 160, head: head };
    if (this.mist) this.mist.fit();
  };

  Shelf.prototype.setMode = function () {
    this.hoverMode = hoverMQ.matches;
    this.root.classList.toggle('is-hover-mode', this.hoverMode);
    this.layoutPadding();
  };

  Shelf.prototype.layoutPadding = function () {
    var vw = this.viewport.clientWidth, m = this.m;
    var pad = 32;
    var natural = this.visible.length * m.slot + pad * 2;
    this.centerMode = !this.hoverMode && natural > vw;
    if (this.centerMode) pad = Math.max(pad, Math.round(vw / 2 - m.slot / 2));
    this.track.style.paddingLeft = pad + 'px';
    this.track.style.paddingRight = pad + 'px';
    this.root.classList.toggle('is-center-mode', this.centerMode);
    this.overflow = this.track.offsetWidth > vw + 2;
    this.stage.classList.toggle('has-overflow', this.overflow);
    this.viewport.classList.toggle('has-overflow', this.overflow);
    var show = this.overflow && this.hoverMode;
    if (this.prevBtn) this.prevBtn.hidden = !show;
    if (this.nextBtn) this.nextBtn.hidden = !show;
    this.updateArrows();
  };

  Shelf.prototype.updateArrows = function () {
    if (!this.prevBtn || this.prevBtn.hidden) return;
    var vi = this.visible.indexOf(this.active);
    this.prevBtn.disabled = vi <= 0;
    this.nextBtn.disabled = vi === -1 || vi >= this.visible.length - 1;
  };

  /* ---------- entrance and visibility ---------- */
  Shelf.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) { this.inView = true; this.intro(); return; }
    this.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        self.inView = e.isIntersecting;
        if (e.isIntersecting && !self.introDone) self.intro();
        if (e.isIntersecting) self.kick();
      });
    }, { threshold: 0.15 });
    this.io.observe(this.root);
  };

  Shelf.prototype.intro = function () {
    var self = this;
    if (this.introDone) return;
    this.introDone = true;
    if (this.reduced) return;
    var list = this.visible;
    list.forEach(function (it, n) { it.li.style.transitionDelay = (n * 90) + 'ms'; });
    void this.track.offsetWidth;
    this.root.classList.remove('is-pre');
    setTimeout(function () {
      list.forEach(function (it) { it.li.style.transitionDelay = ''; });
      self.startActive(true);
    }, list.length * 90 + 900);
  };

  Shelf.prototype.startActive = function (animate) {
    if (this.active) return;
    var n = Number(this.cfg.startItem) || 0;
    var it = n > 0 && this.items[n - 1] && this.items[n - 1].visible ? this.items[n - 1] : this.middle();
    if (!it) return;
    if (this.centerMode) this.scrollToItem(it, false);
    this.activate(it, { quiet: !animate });
  };

  Shelf.prototype.middle = function () {
    var list = this.visible;
    if (!list.length) return null;
    if (this.overflow) return this.nearest(this.viewport.scrollLeft + this.viewport.clientWidth / 2);
    return list[Math.floor((list.length - 1) / 2)];
  };

  Shelf.prototype.nearest = function (center) {
    var best = null, bd = Infinity, half = this.m.slot / 2;
    this.visible.forEach(function (it) {
      var d = Math.abs(it.li.offsetLeft + half - center);
      if (d < bd) { bd = d; best = it; }
    });
    return best;
  };

  /* ---------- lifting a bottle ---------- */
  Shelf.prototype.activate = function (it, opts) {
    opts = opts || {};
    if (!it || it === this.active) return;
    if (this.active) this.active.li.classList.remove('is-active');
    this.active = it;
    it.li.classList.add('is-active');
    this.root.classList.add('has-active');
    this.root.style.setProperty('--mist', it.data.mist || '#d9c7a3');
    this.updateInfo(it, !!opts.quiet);
    this.place();
    this.showNotes(it);
    this.burstLeft = this.mist ? 8 + this.mistAmount * 2 : 0;
    this.updateArrows();
    this.roving(it);
    this.kick();
  };

  Shelf.prototype.roving = function (it) {
    this.items.forEach(function (x) { x.bottle.setAttribute('tabindex', x === it ? '0' : '-1'); });
  };

  // Where the active bottle stands, in stage coordinates.
  Shelf.prototype.anchor = function () {
    var it = this.active;
    if (!it) return null;
    var sr = this.stage.getBoundingClientRect();
    var lr = it.li.getBoundingClientRect();
    var x = lr.left + lr.width / 2 - sr.left;
    var y = this.m.head + this.m.H * 0.055 - this.m.H * 0.11 - 6;
    return { x: x, y: y };
  };

  Shelf.prototype.place = function () {
    var a = this.anchor();
    if (!a) return;
    if (this.spot) this.spot.style.left = a.x.toFixed(1) + 'px';
    if (this.notesEl) this.notesEl.style.transform = 'translate3d(' + a.x.toFixed(1) + 'px,' + a.y.toFixed(1) + 'px,0)';
  };

  Shelf.prototype.showNotes = function (it) {
    var el = this.notesEl;
    if (!el || !this.cfg.showNotes) return;
    [].forEach.call(el.querySelectorAll('.bps-cloud'), function (c) {
      c.classList.add('is-out');
      setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 650);
    });
    var n = it.notes, t = this.text;
    if (!n.any) return;
    var rows = n.key ? [[t.notes || 'Notes', n.key]] : [[t.top || 'Top', n.top], [t.heart || 'Heart', n.heart], [t.base || 'Base', n.base]];
    var html = '';
    var start = this.reduced ? 0 : 0.35;
    rows.forEach(function (r, ri) {
      if (!r[1] || !r[1].length) return;
      var d0 = start + ri * 0.55;
      var words = r[1].slice(0, 3).map(function (w, wi) {
        return (wi ? '<span class="bps-cloud__dot">·</span>' : '') + '<span class="bps-cloud__w" style="--d:' + (d0 + 0.12 + wi * 0.14).toFixed(2) + 's">' + esc(w) + '</span>';
      }).join('');
      html += '<div class="bps-cloud__row"><span class="bps-cloud__label" style="--d:' + d0.toFixed(2) + 's">' + esc(r[0]) + '</span><span class="bps-cloud__words">' + words + '</span></div>';
    });
    var c = document.createElement('div');
    c.className = 'bps-cloud';
    c.innerHTML = html;
    el.appendChild(c);
  };

  Shelf.prototype.updateInfo = function (it, instant) {
    var self = this, d = it.data, root = this.root;
    clearTimeout(this.infoTimer);
    var fill = function () {
      root.querySelector('[data-bps-info-eyebrow]').textContent = [d.group, d.badge].filter(Boolean).join(' · ');
      root.querySelector('[data-bps-info-title]').textContent = d.title || '';
      root.querySelector('[data-bps-info-mood]').textContent = it.mood || '';
      var v = defaultSize(it.sizes);
      var meta = '';
      if (self.cfg.showPrice && v) meta = (v.label ? esc(v.label) + ' · ' : '') + esc(v.price) + (v.compare ? '<s>' + esc(v.compare) + '</s>' : '');
      root.querySelector('[data-bps-info-meta]').innerHTML = meta;
      if (self.openBtn) self.openBtn.setAttribute('aria-label', (self.openBtn.textContent || '').trim() + ': ' + d.title);
      self.infoBody.classList.remove('is-out');
    };
    if (instant || this.reduced) { fill(); return; }
    this.infoBody.classList.add('is-out');
    this.infoTimer = setTimeout(fill, 170);
  };

  /* ---------- animation loop (mist, follow the scroll) ---------- */
  Shelf.prototype.kick = function () {
    if (this.running || !this.inView || document.hidden || this.destroyed) return;
    var self = this;
    this.running = true;
    this.lastTime = 0;
    requestAnimationFrame(function (t) { self.tick(t); });
  };

  Shelf.prototype.tick = function (now) {
    var self = this;
    if (!this.inView || document.hidden || this.destroyed) { this.running = false; return; }
    var dt = this.lastTime ? Math.min(0.05, (now - this.lastTime) / 1000) : 0.016;
    this.lastTime = now;
    var sl = this.viewport.scrollLeft;
    var ds = sl - this.lastScroll;
    this.lastScroll = sl;
    if (ds) { this.place(); if (this.mist) this.mist.shift(-ds); }

    var alive = 0;
    if (this.mist) {
      var it = this.active;
      if (it && !this.paused) {
        var r = it.lift.getBoundingClientRect(), sr = this.stage.getBoundingClientRect();
        var x = r.left + r.width / 2 - sr.left, y = r.top + r.height * 0.075 - sr.top;
        if (this.burstLeft > 0) {
          var n = Math.min(this.burstLeft, Math.ceil(dt * 36));
          this.mist.add(x, y, it.data.mist, n, 1.15, this.m.H / 400);
          this.burstLeft -= n;
        }
        this.emitAcc = (this.emitAcc || 0) + dt * this.mistAmount * 0.6;
        while (this.emitAcc >= 1) { this.mist.add(x, y, it.data.mist, 1, 0.8, this.m.H / 400); this.emitAcc -= 1; }
      }
      alive = this.mist.step(dt, now / 1000);
    }
    var keep = alive > 0 || (this.mist && this.active && !this.paused) || ds;
    if (keep) requestAnimationFrame(function (tt) { self.tick(tt); });
    else this.running = false;
  };

  /* ---------- phones: the bottle in the middle lifts ---------- */
  Shelf.prototype.centerCheck = function () {
    if (this.filtering) return;
    var c = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
    var it = this.nearest(c);
    if (!it || it === this.active) return;
    var half = this.m.slot / 2;
    var dNew = Math.abs(it.li.offsetLeft + half - c);
    var dOld = this.active ? Math.abs(this.active.li.offsetLeft + half - c) : Infinity;
    if (dNew + 6 < dOld) this.activate(it);
  };

  Shelf.prototype.scrollToItem = function (it, smoothScroll) {
    var left = it.li.offsetLeft + this.m.slot / 2 - this.viewport.clientWidth / 2;
    left = clamp(left, 0, this.viewport.scrollWidth - this.viewport.clientWidth);
    if (Math.abs(left - this.viewport.scrollLeft) < 2) return;
    try { this.viewport.scrollTo({ left: left, behavior: smoothScroll && !this.reduced ? 'smooth' : 'auto' }); }
    catch (e) { this.viewport.scrollLeft = left; }
  };

  Shelf.prototype.ensureVisible = function (it, smoothScroll) {
    if (!this.overflow) return;
    var vp = this.viewport, l = it.li.offsetLeft - 40, r = it.li.offsetLeft + this.m.slot + 40;
    if (l < vp.scrollLeft || r > vp.scrollLeft + vp.clientWidth) this.scrollToItem(it, smoothScroll);
  };

  /* ---------- events ---------- */
  Shelf.prototype.itemFrom = function (el) {
    var li = el && el.closest ? el.closest('[data-bps-item]') : null;
    if (!li) return null;
    for (var n = 0; n < this.items.length; n++) if (this.items[n].li === li) return this.items[n];
    return null;
  };

  Shelf.prototype.bind = function () {
    var self = this, vp = this.viewport;

    this.on(this.track, 'pointerover', function (e) {
      if (e.pointerType !== 'mouse' || !self.hoverMode || !self.cfg.hoverLift || self.drag) return;
      var it = self.itemFrom(e.target);
      if (!it || !it.visible) return;
      self.hoverItem = it;
      clearTimeout(self.hoverTimer);
      self.hoverTimer = setTimeout(function () { if (self.hoverItem === it && !self.drag) self.activate(it); }, 90);
    });
    this.on(this.track, 'pointerleave', function () { self.hoverItem = null; clearTimeout(self.hoverTimer); });

    this.on(vp, 'pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !self.overflow) return;
      cancelAnimationFrame(self.glideRaf);
      self.drag = { x: e.clientX, left: vp.scrollLeft, moved: false, id: e.pointerId, v: 0, lx: e.clientX, lt: performance.now() };
      self.dragMoved = false;
    });
    this.on(window, 'pointermove', function (e) {
      var d = self.drag;
      if (!d || e.pointerId !== d.id) return;
      var dx = e.clientX - d.x;
      if (!d.moved && Math.abs(dx) > 6) { d.moved = true; self.dragMoved = true; self.root.classList.add('is-dragging'); clearTimeout(self.hoverTimer); }
      if (d.moved) {
        vp.scrollLeft = d.left - dx;
        var now = performance.now();
        if (now > d.lt) d.v = (e.clientX - d.lx) / (now - d.lt);
        d.lx = e.clientX; d.lt = now;
        self.kick();
      }
    });
    var endDrag = function (e) {
      var d = self.drag;
      if (!d || (e.pointerId !== undefined && e.pointerId !== d.id)) return;
      self.drag = null;
      self.root.classList.remove('is-dragging');
      if (d.moved && !self.reduced) {
        var v = -d.v * 16;
        var step = function () { v *= 0.93; vp.scrollLeft += v; if (Math.abs(v) > 0.4) self.glideRaf = requestAnimationFrame(step); };
        self.glideRaf = requestAnimationFrame(step);
      }
    };
    this.on(window, 'pointerup', endDrag);
    this.on(window, 'pointercancel', endDrag);

    this.on(this.track, 'click', function (e) {
      var it = self.itemFrom(e.target);
      if (!it) return;
      if (self.dragMoved) { e.preventDefault(); self.dragMoved = false; return; }
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      var isActive = it === self.active;
      if (!isActive && (!self.hoverMode || !self.cfg.hoverLift)) {
        e.preventDefault();
        if (self.centerMode) self.scrollToItem(it, true);
        self.activate(it);
        if (self.hoverMode) self.ensureVisible(it, true);
        return;
      }
      if (self.cfg.onClick === 'product') return;
      e.preventDefault();
      self.activate(it);
      self.open(it);
    });

    if (this.openBtn) {
      this.on(this.openBtn, 'click', function () {
        var it = self.active || self.middle();
        if (!it) return;
        if (self.cfg.onClick === 'product' && it.data.url) { window.location.href = it.data.url; return; }
        self.activate(it, { quiet: true });
        self.open(it);
      });
    }

    this.on(this.track, 'pointerdown', function () {
      self.pointerFocus = true;
      clearTimeout(self.pointerFocusTimer);
      self.pointerFocusTimer = setTimeout(function () { self.pointerFocus = false; }, 700);
    });
    this.on(this.track, 'focusin', function (e) {
      if (self.pointerFocus) return;
      var it = self.itemFrom(e.target);
      if (!it || it === self.active) return;
      self.activate(it);
      if (self.centerMode) self.scrollToItem(it, true); else self.ensureVisible(it, true);
    });
    this.on(this.track, 'keydown', function (e) {
      var it = self.itemFrom(e.target);
      if (!it) return;
      var vi = self.visible.indexOf(it), next = null;
      if (e.key === 'ArrowRight') next = self.visible[vi + 1];
      else if (e.key === 'ArrowLeft') next = self.visible[vi - 1];
      else if (e.key === 'Home') next = self.visible[0];
      else if (e.key === 'End') next = self.visible[self.visible.length - 1];
      else return;
      e.preventDefault();
      if (next) next.bottle.focus({ preventScroll: true });
    });

    var step = function (dir) {
      var vi = self.visible.indexOf(self.active);
      var it = self.visible[clamp(vi + dir, 0, self.visible.length - 1)];
      if (!it || it === self.active) return;
      self.activate(it);
      self.scrollToItem(it, true);
    };
    if (this.prevBtn) this.on(this.prevBtn, 'click', function () { step(-1); });
    if (this.nextBtn) this.on(this.nextBtn, 'click', function () { step(1); });

    this.on(vp, 'scroll', function () {
      self.kick();
      if (!self.scrollRaf) {
        self.scrollRaf = requestAnimationFrame(function () {
          self.scrollRaf = 0;
          self.place();
          if (self.centerMode) self.centerCheck();
        });
      }
    }, { passive: true });

    if (this.tabsEl) {
      this.on(this.tabsEl, 'click', function (e) {
        var b = e.target.closest('[data-bps-tab]');
        if (b) self.setFilter(b.getAttribute('data-bps-tab'));
      });
    }

    var onResize = function () {
      cancelAnimationFrame(self.resizeRaf);
      self.resizeRaf = requestAnimationFrame(function () {
        self.measure();
        self.setMode();
        self.place();
        self.moveTabLine(false);
      });
    };
    if ('ResizeObserver' in window) { this.ro = new ResizeObserver(onResize); this.ro.observe(this.viewport); }
    else this.on(window, 'resize', onResize);
    if (hoverMQ.addEventListener) { hoverMQ.addEventListener('change', onResize); this.mqListener = onResize; }
    this.on(document, 'visibilitychange', function () { self.kick(); });
  };

  /* ---------- filter tabs ---------- */
  Shelf.prototype.updateTabs = function (animate) {
    if (!this.tabsEl) return;
    var key = this.filter;
    [].forEach.call(this.tabsEl.querySelectorAll('[data-bps-tab]'), function (b) {
      var on = b.getAttribute('data-bps-tab') === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.moveTabLine(animate);
  };

  Shelf.prototype.moveTabLine = function (animate) {
    if (!this.tabLine || !this.tabsEl) return;
    var b = this.tabsEl.querySelector('[data-bps-tab].is-active');
    if (!b) return;
    if (!animate) this.tabLine.style.transition = 'none';
    this.tabLine.style.width = b.offsetWidth + 'px';
    this.tabLine.style.transform = 'translate3d(' + b.offsetLeft + 'px,' + (b.offsetTop + b.offsetHeight - 3) + 'px,0)';
    if (!animate) { void this.tabLine.offsetWidth; this.tabLine.style.transition = ''; }
  };

  Shelf.prototype.setFilter = function (key) {
    var self = this;
    if (key === this.filter || this.filtering) return;
    this.filter = key;
    this.updateTabs(true);
    var match = function (it) { return key === 'all' || it.group === key; };
    var leaving = this.items.filter(function (it) { return it.visible && !match(it); });
    var entering = this.items.filter(function (it) { return !it.visible && match(it); });
    var staying = this.items.filter(function (it) { return it.visible && match(it); });
    if (!leaving.length && !entering.length) return;
    this.filtering = true;
    var first = staying.map(function (it) { return it.li.getBoundingClientRect().left; });
    leaving.forEach(function (it) { it.li.classList.add('is-leaving'); });

    setTimeout(function () {
      leaving.forEach(function (it) { it.li.hidden = true; it.li.classList.remove('is-leaving', 'is-active'); it.visible = false; });
      entering.forEach(function (it) { it.li.hidden = false; it.visible = true; it.li.classList.add('is-entering'); });
      self.visible = self.items.filter(function (it) { return it.visible; });
      if (self.active && !self.active.visible) self.active = null;
      self.measure();
      self.layoutPadding();
      var keep = self.active || self.middle();
      if (keep && self.overflow) self.viewport.scrollLeft = clamp(keep.li.offsetLeft + self.m.slot / 2 - self.viewport.clientWidth / 2, 0, self.viewport.scrollWidth - self.viewport.clientWidth);
      else self.viewport.scrollLeft = 0;
      self.lastScroll = self.viewport.scrollLeft;

      staying.forEach(function (it, n) {
        var dx = first[n] - it.li.getBoundingClientRect().left;
        it.li.style.transition = 'none';
        it.li.style.transform = 'translate3d(' + dx.toFixed(1) + 'px,0,0)';
      });
      void self.track.offsetWidth;
      staying.forEach(function (it) { it.li.style.transition = ''; it.li.style.transform = ''; });
      entering.forEach(function (it, n) {
        setTimeout(function () { it.li.classList.remove('is-entering'); }, 90 + n * 90);
      });

      if (keep && keep !== self.active) {
        self.active = null;
        self.activate(keep);
      } else {
        self.place();
      }
      if (self.mist) self.mist.clear();
      self.updateArrows();
      self.roving(self.active);
      setTimeout(function () { self.filtering = false; self.place(); }, 1000 + entering.length * 90);
    }, leaving.length ? 330 : 0);
  };

  /* ---------- details panel ---------- */
  Shelf.prototype.buildPanel = function () {
    var self = this, t = this.text;
    var p = document.createElement('div');
    p.className = 'bps-panel';
    p.hidden = true;
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-modal', 'true');
    p.setAttribute('aria-labelledby', this.id + '-title');
    p.setAttribute('style', this.root.getAttribute('style') || '');
    p.innerHTML =
      '<div class="bps-panel__backdrop"></div>' +
      '<button type="button" class="bps-panel__close" data-bps-close aria-label="' + esc(t.close || 'Close') + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.3"/></svg></button>' +
      '<div class="bps-panel__sheet" data-bps-sheet>' +
        '<div class="bps-panel__stage">' +
          '<div class="bps-panel__halo" aria-hidden="true"></div>' +
          '<canvas class="bps-panel__canvas" aria-hidden="true"></canvas>' +
          '<div class="bps-panel__view" data-bps-view tabindex="0" role="button">' +
            '<img class="bps-panel__bottle" alt="" draggable="false" decoding="async">' +
            '<img class="bps-panel__photo" alt="" draggable="false" decoding="async" hidden>' +
          '</div>' +
          '<div class="bps-panel__controls">' +
            '<div class="bps-panel__views" role="group" aria-label="' + esc(t.views || 'View') + '" data-bps-views hidden>' +
              '<button type="button" class="bps-panel__vbtn" data-bps-v="bottle" aria-pressed="true">' + esc(t.bottle || 'Bottle') + '</button>' +
              '<button type="button" class="bps-panel__vbtn" data-bps-v="photo" aria-pressed="false">' + esc(t.box || 'With box') + '</button>' +
            '</div>' +
            '<p class="bps-panel__spray" data-bps-spray>' + esc(t.spray || 'Tap the bottle to spray') + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="bps-panel__info">' +
          '<p class="bps-panel__eyebrow" data-p-eyebrow></p>' +
          '<h2 class="bps-panel__title" id="' + this.id + '-title" data-p-title></h2>' +
          '<p class="bps-panel__mood" data-p-mood></p>' +
          '<dl class="bps-panel__pyramid" data-p-pyramid></dl>' +
          '<div data-p-size-wrap><p class="bps-panel__size-label" id="' + this.id + '-size">' + esc(t.size || 'Size') + '</p>' +
          '<div class="bps-panel__sizes" role="radiogroup" aria-labelledby="' + this.id + '-size" data-p-sizes></div></div>' +
          '<form class="bps-panel__form" method="post" action="' + esc(this.cfg.cartRoot || '/cart/add') + '" accept-charset="UTF-8">' +
            '<input type="hidden" name="form_type" value="product">' +
            '<input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" name="id" value="" data-p-variant>' +
            '<input type="hidden" name="quantity" value="1">' +
            '<input type="hidden" name="properties[_From]" value="Perfume shelf">' +
            '<button type="submit" class="bps__btn bps__btn--solid" data-add-to-cart data-p-add><span data-p-add-label></span></button>' +
          '</form>' +
          '<a class="bps-panel__link" href="#" data-p-link>' + esc(t.viewProduct || 'View full details') + '</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(p);
    this.panel = p;
    this.pView = p.querySelector('[data-bps-view]');
    this.pBottle = p.querySelector('.bps-panel__bottle');
    this.pPhoto = p.querySelector('.bps-panel__photo');
    this.pViews = p.querySelector('[data-bps-views]');
    this.pSpray = p.querySelector('[data-bps-spray]');
    this.pClose = p.querySelector('.bps-panel__close');
    this.pSheet = p.querySelector('[data-bps-sheet]');
    var canvas = p.querySelector('.bps-panel__canvas');
    this.pMist = !this.reduced && canvas.getContext ? new Mist(canvas, 2) : null;

    this.on(p, 'click', function (e) {
      var outside = e.target === self.pSheet || e.target.classList.contains('bps-panel__stage');
      if (e.target.closest('[data-bps-close]') || outside) { self.close(); return; }
      var vb = e.target.closest('[data-bps-v]');
      if (vb) { self.showView(vb.getAttribute('data-bps-v')); return; }
      var sz = e.target.closest('[data-bps-size]');
      if (sz && !sz.disabled) { self.pickSize(Number(sz.getAttribute('data-bps-size'))); return; }
      if (e.target.closest('[data-bps-view]')) self.spray(true);
    });
    this.on(p, 'keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
      if (e.key === 'Tab') self.trap(e);
      if (e.target === self.pView && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); self.spray(true); }
      var sz = e.target.closest && e.target.closest('[data-bps-size]');
      if (sz && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        var all = [].slice.call(p.querySelectorAll('[data-bps-size]:not(:disabled)'));
        var k = all.indexOf(sz) + (e.key === 'ArrowRight' ? 1 : -1);
        var nb = all[(k + all.length) % all.length];
        nb.focus(); nb.click();
      }
    });
    var add = p.querySelector('[data-p-add]');
    this.on(add, 'click', function () {
      if (add.disabled) return;
      if (window.theme) setTimeout(function () { self.close(true); }, 60);
    });
  };

  Shelf.prototype.trap = function (e) {
    var f = [].filter.call(this.panel.querySelectorAll('button, a[href], [tabindex="0"]'), function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  };

  Shelf.prototype.fillPanel = function (it) {
    var p = this.panel, d = it.data, t = this.text;
    p.style.setProperty('--mist', d.mist || '#d9c7a3');
    var b = d.bottle || {};
    this.pBottle.sizes = '(max-width: 899px) 60vw, 480px';
    if (b.srcset) this.pBottle.srcset = b.srcset;
    this.pBottle.src = resize(b.src, 900);
    this.pBottle.alt = d.title || '';
    this.pView.setAttribute('aria-label', (d.title || '') + '. ' + (t.spray || ''));
    var hasPhoto = !!d.photo;
    this.pPhoto.hidden = !hasPhoto;
    if (hasPhoto) { this.pPhoto.src = d.photo; this.pPhoto.alt = (d.title || '') + ' ' + (t.box || ''); }
    this.pViews.hidden = !hasPhoto;
    this.showView('bottle', true);

    p.querySelector('[data-p-eyebrow]').textContent = [d.group, d.badge].filter(Boolean).join(' · ');
    p.querySelector('[data-p-title]').textContent = d.title || '';
    p.querySelector('[data-p-mood]').textContent = it.mood || '';
    var n = it.notes, rows = n.key ? [[t.notes || 'Notes', n.key]] : [[t.top || 'Top', n.top], [t.heart || 'Heart', n.heart], [t.base || 'Base', n.base]];
    p.querySelector('[data-p-pyramid]').innerHTML = rows.filter(function (r) { return r[1] && r[1].length; }).map(function (r) {
      return '<div class="bps-panel__prow"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1].join(', ')) + '</dd></div>';
    }).join('');

    var sizes = it.sizes;
    var showSizes = sizes.length > 1 || (sizes[0] && sizes[0].label);
    p.querySelector('[data-p-size-wrap]').hidden = !showSizes;
    p.querySelector('[data-p-sizes]').innerHTML = sizes.map(function (v, k) {
      return '<button type="button" class="bps-panel__size" role="radio" aria-checked="false" tabindex="-1" data-bps-size="' + k + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.label || v.price) + '</button>';
    }).join('');
    var link = p.querySelector('[data-p-link]');
    link.href = d.url || '#';
    link.hidden = !d.url;
    this.pItem = it;
    var def = defaultSize(sizes);
    this.pickSize(def ? sizes.indexOf(def) : -1);
  };

  Shelf.prototype.pickSize = function (k) {
    var p = this.panel, it = this.pItem, t = this.text;
    var v = it && it.sizes[k];
    [].forEach.call(p.querySelectorAll('[data-bps-size]'), function (b, n) {
      b.setAttribute('aria-checked', n === k ? 'true' : 'false');
      b.setAttribute('tabindex', n === k ? '0' : '-1');
    });
    var add = p.querySelector('[data-p-add]');
    p.querySelector('[data-p-variant]').value = v ? v.id : '';
    add.disabled = !v || !v.available;
    p.querySelector('[data-p-add-label]').textContent = v && v.available ? (t.add || 'Add to bag') + (this.cfg.showPrice && v.price ? ' · ' + v.price : '') : (t.soldOut || 'Sold out');
  };

  Shelf.prototype.showView = function (v, instant) {
    var photo = v === 'photo' && !this.pPhoto.hidden;
    this.pView.classList.toggle('show-photo', photo);
    [].forEach.call(this.pViews.querySelectorAll('[data-bps-v]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bps-v') === (photo ? 'photo' : 'bottle') ? 'true' : 'false'); });
    this.pShowPhoto = photo;
  };

  Shelf.prototype.nozzle = function () {
    var c = this.pMist.canvas.getBoundingClientRect(), r = this.pBottle.getBoundingClientRect();
    return { x: r.left + r.width / 2 - c.left, y: r.top + r.height * 0.075 - c.top, s: r.height / 400 };
  };

  Shelf.prototype.spray = function (user) {
    var self = this;
    if (user && this.pSpray) this.pSpray.classList.add('is-done');
    if (this.pShowPhoto) this.showView('bottle');
    this.pView.classList.remove('is-spray');
    void this.pView.offsetWidth;
    this.pView.classList.add('is-spray');
    if (!this.pMist) return;
    this.pMist.fit();
    var n = this.nozzle();
    this.pMist.add(n.x, n.y, this.pItem.data.mist, 24, 1.3, n.s * 0.9);
    this.panelLoop();
  };

  Shelf.prototype.panelLoop = function () {
    var self = this;
    if (this.pRunning || !this.pMist) return;
    this.pRunning = true;
    var last = 0, acc = 0;
    var step = function (now) {
      if (!self.panelOpen && !self.pMist.parts.length) { self.pRunning = false; self.pMist.clear(); return; }
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 0.016;
      last = now;
      if (self.panelOpen && !self.pShowPhoto) {
        acc += dt * 1.6;
        if (acc >= 1) { var n = self.nozzle(); self.pMist.add(n.x, n.y, self.pItem.data.mist, 1, 0.75, n.s * 0.9); acc -= 1; }
      }
      self.pMist.step(dt, now / 1000);
      self.pRaf = requestAnimationFrame(step);
    };
    this.pRaf = requestAnimationFrame(step);
  };

  Shelf.prototype.lock = function (on) {
    var html = document.documentElement;
    if (on) {
      var sb = window.innerWidth - html.clientWidth;
      html.classList.add('bps-lock');
      if (sb > 0) html.style.paddingRight = sb + 'px';
    } else {
      html.classList.remove('bps-lock');
      html.style.paddingRight = '';
    }
  };

  Shelf.prototype.fly = function (fromEl, toEl, src, ms, done) {
    var a = fromEl.getBoundingClientRect(), b = toEl.getBoundingClientRect();
    if (!a.width || !b.width || !src || this.reduced || !document.body.animate) { if (done) done(); return; }
    var fl = document.createElement('img');
    fl.className = 'bps-flyer';
    fl.alt = '';
    fl.src = src;
    fl.style.left = b.left + 'px'; fl.style.top = b.top + 'px'; fl.style.width = b.width + 'px'; fl.style.height = b.height + 'px';
    document.body.appendChild(fl);
    var anim = fl.animate([
      { transform: 'translate(' + (a.left - b.left) + 'px,' + (a.top - b.top) + 'px) scale(' + (a.width / b.width) + ',' + (a.height / b.height) + ')' },
      { transform: 'translate(0,0) scale(1,1)' }
    ], { duration: ms, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'forwards' });
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      if (done) done();
      requestAnimationFrame(function () { if (fl.parentNode) fl.parentNode.removeChild(fl); });
    };
    anim.onfinish = finish;
    setTimeout(finish, ms + 300);
  };

  Shelf.prototype.open = function (it) {
    var self = this;
    if (!it || this.panelOpen) return;
    if (!this.panel) this.buildPanel();
    this.panelOpen = true;
    this.lastFocus = document.activeElement;
    this.paused = true;
    this.fillPanel(it);
    if (this.pSpray) this.pSpray.classList.remove('is-done');
    this.panel.classList.remove('is-closing');
    this.panel.hidden = false;
    this.lock(true);
    var from = it.img, to = this.pBottle;
    var src = from && (from.currentSrc || from.src);
    var canFly = !this.reduced && from && from.complete && from.naturalWidth > 0;
    if (canFly) { to.style.visibility = 'hidden'; from.style.visibility = 'hidden'; }
    requestAnimationFrame(function () {
      self.panel.classList.add('is-open');
      try { self.pClose.focus({ preventScroll: true }); } catch (e) { self.pClose.focus(); }
      var landed = function () {
        to.style.visibility = '';
        if (from) from.style.visibility = '';
        setTimeout(function () { if (self.panelOpen) self.spray(false); }, 120);
      };
      if (canFly) self.fly(from, to, src, 860, landed);
      else setTimeout(landed, 300);
    });
  };

  Shelf.prototype.close = function (forCart) {
    var self = this;
    if (!this.panelOpen) return;
    this.panelOpen = false;
    var it = this.pItem, p = this.panel;
    var to = it && it.visible ? it.img : null;
    var from = this.pShowPhoto ? null : this.pBottle;
    if (to && this.overflow) this.ensureVisible(it, false);
    var canFly = !forCart && !this.reduced && to && from && from.complete && from.naturalWidth > 0;
    p.classList.add('is-closing');
    p.classList.remove('is-open');
    var finish = function () {
      p.hidden = true;
      p.classList.remove('is-closing');
      self.lock(false);
      self.paused = false;
      self.burstLeft = 0;
      self.kick();
      if (to) to.style.visibility = '';
      if (from) from.style.visibility = '';
      if (!forCart && self.lastFocus && document.contains(self.lastFocus)) {
        var back = it && it.visible ? it.bottle : self.lastFocus;
        try { back.focus({ preventScroll: true }); } catch (e) {}
      }
    };
    if (canFly) {
      from.style.visibility = 'hidden';
      to.style.visibility = 'hidden';
      this.fly(from, to, from.currentSrc || from.src, 780, finish);
    } else {
      setTimeout(finish, forCart ? 280 : 420);
    }
  };

  /* ---------- theme editor ---------- */
  Shelf.prototype.selectBlock = function (blockId) {
    var self = this, it = null;
    this.items.forEach(function (x) { if (x.blockId === blockId) it = x; });
    if (!it) return;
    var go = function () { self.activate(it); if (self.overflow) self.scrollToItem(it, true); };
    if (!it.visible) { this.setFilter('all'); setTimeout(go, 800); } else go();
  };

  Shelf.prototype.destroy = function () {
    this.destroyed = true;
    this.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    this.listeners = [];
    if (this.io) this.io.disconnect();
    if (this.ro) this.ro.disconnect();
    if (this.mqListener && hoverMQ.removeEventListener) hoverMQ.removeEventListener('change', this.mqListener);
    cancelAnimationFrame(this.glideRaf);
    cancelAnimationFrame(this.pRaf);
    if (this.panel && this.panel.parentNode) this.panel.parentNode.removeChild(this.panel);
    this.lock(false);
  };

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-bps]'), function (el) {
      if (el.__bps) return;
      el.__bps = new Shelf(el);
    });
  }

  window.BisouPerfumeShelf = { init: init, Shelf: Shelf, parseNotes: parseNotes };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-bps]'), function (el) {
      if (el.__bps && el.__bps.destroy) el.__bps.destroy();
      el.__bps = null;
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest && e.target.closest('[data-bps]');
    if (el && el.__bps && el.__bps.selectBlock) el.__bps.selectBlock(e.detail && e.detail.blockId);
  });
})();